import { render, staticRenderFns } from "./InventoryRecords.vue?vue&type=template&id=737bac0e&scoped=true"
import script from "./InventoryRecords.vue?vue&type=script&lang=js"
export * from "./InventoryRecords.vue?vue&type=script&lang=js"
import style0 from "./InventoryRecords.vue?vue&type=style&index=0&id=737bac0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737bac0e",
  null
  
)

export default component.exports